import { Box, Button, Typography } from "@mui/material";
import { ComparisonPane } from "./comparison-pane";
import { useEffect, useRef, useState } from "react";
import { useUserContext } from "../../../services/context/user-context";

export function tallyEmbedUrl(tallyId, leftId, rightId, projectId, userId) {
  return `https://tally.so/embed/${tallyId}?leftId=${leftId}&rightId=${rightId}&projectId=${projectId}&userId=${userId}`;
}

export const SurveyWrapper = ({
  projectId,
  leftResult,
  rightResult,
  onSkipHandler,
}) => {
  const { userData, surveyTallyId } = useUserContext();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", width: "100%", height: "60%", minHeight: "60%" }}
      >
        <Box
          sx={{
            position: "relative",
            flex: 1,
            minWidth: 0,
            height: "100%",
          }}
        >
          <ComparisonPane
            mapId="compare-map-left"
            projectId={projectId}
            selectedRunner={leftResult.runner}
            selectedResult={leftResult.result}
            isLeftSide={true}
          />
        </Box>

        <Box
          sx={{
            /* width: "6px", */ background: "#FBFBFD",
            boxShadow: 2,
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: '8px'
          }}
        >
          <Button
          size="small"
            sx={{
              minWidth: 0,
              background: "#fff",
              color: "#343745",
              textTransform: "none",
              boxShadow: 2,
              ":hover": {
                boxShadow: 4,
              },
            }}
            onClick={onSkipHandler}
          >
            Skip
          </Button>
        </Box>

        <Box
          sx={{
            position: "relative",
            flex: 1,
            minWidth: 0,
            height: "100%",
          }}
        >
          <ComparisonPane
            mapId="compare-map-right"
            projectId={projectId}
            selectedRunner={rightResult.runner}
            selectedResult={rightResult.result}
            isLeftSide={false}
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "40%",
          minHeight: "40%",
          background: "#e5e5ef",
        }}
      >
        <Box
          sx={{
            background: "#343745",
            m: "0px 0 12px 0",
            borderRadius: "20px 20px 20px 20px",
            height: "100%",
            boxShadow: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              p: "4px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <IconSurvey width={"22px"} height={"22px"} fill="#efa21e" /> */}
            <Typography className="nav-text" color="#efa21e">
              Survey
            </Typography>
          </Box>
          <Box
            component="iframe"
            src={tallyEmbedUrl(
              surveyTallyId,
              leftResult.result.resultId,
              rightResult.result.resultId,
              projectId,
              userData.userId,
            )}
            sx={{
              width: "100%",
              height: "calc(100% - 26px)",
              border: 0,
              borderRadius: "20px 20px 20px 20px",
            }}
            title={`preview-${surveyTallyId}`}
            allowFullScreen
          />
        </Box>
      </Box>
    </Box>
  );
};
